<ng-container [ngSwitch]="filterTypeByName.get(name)">
  <div class="field-wrapper" [ngClass]="{ 'dragged-mode': isDraggedMode }">
    <div class="field-action-button" (click)="changeFieldState.emit(name)">
      <ui-svg-icon [name]="isFieldEnabled ? iconNameList.Close : iconNameList.Add" [width]="20"></ui-svg-icon>
    </div>
    <ng-container *ngSwitchCase="filterType.ChipsInput">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <mat-chip-grid #chipList>
          <mat-chip-row
            *ngFor="let item of filtersFormControlOrGroup.value"
            [removable]="true"
            (removed)="removeFilter(filtersFormControlOrGroup, item)"
          >
            {{ item }}
            <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
          </mat-chip-row>
          <input
            #chipsInput
            [formControl]="chipsInputControl"
            [matChipInputFor]="chipList"
            [matChipInputAddOnBlur]="true"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addElement(filtersFormControlOrGroup, chipsInput, chipsInputControl)"
          />
          <ui-svg-icon
            *ngIf="filtersFormControlOrGroup?.value?.length < 2"
            [name]="iconNameList.ListView"
            class="svg_transform"
            matSuffix
          ></ui-svg-icon>
        </mat-chip-grid>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.ChipsInputPopup">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <mat-chip-grid #chipList (click)="openFilterDialog(name, label, filtersFormControlOrGroup)">
          <mat-chip-row
            *ngFor="let item of filtersFormControlOrGroup.value"
            [removable]="true"
            [matTooltip]="item?.description"
            (removed)="removeFilter(filtersFormControlOrGroup, item)"
          >
            {{ item?.value }}
            <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
          </mat-chip-row>
          <input [matChipInputFor]="chipList" [readOnly]="true" class="pointer" />
          <ui-svg-icon
            *ngIf="filtersFormControlOrGroup?.value?.length < 2"
            [name]="iconNameList.ListView"
            class="svg_transform"
            matSuffix
          ></ui-svg-icon>
        </mat-chip-grid>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.MultipleSelect">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <mat-select [formControl]="filtersFormControlOrGroup" multiple>
          <mat-option *ngFor="let option of filterSelectOptionsByName.get(name)" [value]="option">
            <ng-container *ngIf="translatedFilterTitles.has(option); else withoutTranslation">
              {{ translatedFilterTitles.get(option) | translate }}
            </ng-container>
            <ng-template #withoutTranslation>
              {{ option | monitoringFilterAdjustUiPipe : name }}
              <ng-container *ngIf="name === allocationViewFilterName.UliOrigin">({{ option[0] }})</ng-container>
            </ng-template>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.DropDownSearchSelect">
      <ui-select-search
        [selectControl]="filtersFormControlOrGroup"
        [optionItems]="filterSelectOptionsByName.get(name)"
        [placeholderName]="label"
        [noEntriesFoundLabel]="'common.message.noData' | translate"
      >
      </ui-select-search>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.MultipleDropDownSearchSelect">
      <ui-select-search
        [selectControl]="filtersFormControlOrGroup"
        [optionItems]="filterSelectOptionsByName.get(name)"
        [placeholderName]="label"
        [noEntriesFoundLabel]="'common.message.noData' | translate"
        [isMultiple]="true"
      >
      </ui-select-search>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.DropDownSelect">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <mat-select [formControl]="filtersFormControlOrGroup">
          <mat-option *ngFor="let option of filterSelectOptionsByName.get(name)" [value]="option">
            {{ option.name ?? option | titlecase }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.Input">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <input matInput [formControl]="filtersFormControlOrGroup" />
        <ui-svg-icon [name]="iconNameList.Search" class="svg_transform" matSuffix></ui-svg-icon>
        <mat-error>
          <ui-field-error-messages [control]="filtersFormControlOrGroup"></ui-field-error-messages>
        </mat-error>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.UppercaseInput">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <input matInput controlValueToUpperCase [formControl]="filtersFormControlOrGroup" />
        <ui-svg-icon [name]="iconNameList.Search" class="svg_transform" matSuffix></ui-svg-icon>
        <mat-error>
          <ui-field-error-messages [control]="filtersFormControlOrGroup"></ui-field-error-messages>
        </mat-error>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.RangeDatepicker">
      <ui-date-time-range
        [formControl]="filtersFormControlOrGroup"
        [label]="label"
        [pickerType]="'calendar'"
      ></ui-date-time-range>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.CombinedRangeDatepicker">
      <ui-combined-date-time-range
        [formControl]="filtersFormControlOrGroup"
        [label]="label"
        [pickerType]="'calendar'"
      ></ui-combined-date-time-range>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.Datepicker">
      <ui-datepicker [formControl]="filtersFormControlOrGroup" [label]="label"></ui-datepicker>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.TimePicker">
      <ui-datepicker [formControl]="filtersFormControlOrGroup" [label]="label" [pickerType]="'timer'"></ui-datepicker>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.RangeDatetimepicker">
      <ui-date-time-range [formControl]="filtersFormControlOrGroup" [label]="label"></ui-date-time-range>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.CheckboxListPopup">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <mat-chip-grid #chipList (click)="openFilterCheckboxDialog(label, filtersFormControlOrGroup)">
          <ng-container
            *ngIf="
              filtersFormControlOrGroup.value && this.name.match(userListFilterName.PartnerOwners);
              else compartment
            "
          >
            <span *ngFor="let partner of filtersFormControlOrGroup.value">
              <mat-chip-row [removable]="true" (removed)="removePartner(filtersFormControlOrGroup, partner.id)">
                {{ partner.name }}
                <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
              </mat-chip-row>
            </span>
          </ng-container>
          <ng-template #compartment>
            <span *ngFor="let compartment of filtersFormControlOrGroup.value?.compartments">
              <mat-chip-row [removable]="true" (removed)="removeCompartment(filtersFormControlOrGroup, compartment)">
                {{ compartment?.name }}
                <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
              </mat-chip-row>
              <mat-chip-row
                *ngFor="let dock of compartment?.docks"
                [removable]="true"
                [matTooltip]="compartment?.name"
                (removed)="removeDock(filtersFormControlOrGroup, compartment, dock)"
              >
                {{ dock?.name }}
                <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
              </mat-chip-row>
            </span>
          </ng-template>
          <input [matChipInputFor]="chipList" [readOnly]="true" class="pointer" />
          <ui-svg-icon
            *ngIf="filtersFormControlOrGroup?.value?.length < 2"
            [name]="iconNameList.ListView"
            class="svg_transform"
            matSuffix
          ></ui-svg-icon>
        </mat-chip-grid>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.Checkbox">
      <mat-checkbox [formControl]="filtersFormControlOrGroup">
        {{ label }}
      </mat-checkbox>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.BorderedCheckbox">
      <ui-bordered-control-wrapper>
        <mat-checkbox [formControl]="filtersFormControlOrGroup">
          {{ label }}
        </mat-checkbox>
      </ui-bordered-control-wrapper>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.ChipsInputSearch">
      <ui-chips-with-search
        [label]="label"
        [itemOptions]="filterOptionsFacade[name] | async"
        [selectedItemsControl]="filtersFormControlOrGroup"
        [selectedItems]="selectedChipsInputSearchItems"
        (fetchItemsOptions)="filterOptionsFacade[name + 'LoadAll']($event)"
      >
      </ui-chips-with-search>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.ChipsInputSearchGeneric">
      <ui-chips-with-search-generic
        [label]="label"
        [itemOptions]="filterOptionsFacade[name] | async"
        [selectedItemsControl]="filtersFormControlOrGroup"
        [selectedItems]="selectedChipsInputSearchItems"
        [optionNameKeys]="optionNameKeyForChipsInputSearchGeneric"
        [panelWidth]="searchCheckboxAutocompleteWidth"
        (fetchItemsOptions)="filterOptionsFacade[name + 'LoadAll']($event)"
      >
      </ui-chips-with-search-generic>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.ChipsInputSearchGenericWithCheckboxes">
      <ui-chips-with-search-generic-and-checkboxes
        [label]="label"
        [itemOptions]="filterOptionsFacade[name] | async"
        [selectedItemsControl]="filtersFormControlOrGroup"
        [selectedItems]="selectedChipsInputSearchItems"
        [optionNameKeys]="optionNameKeyForChipsInputSearchGeneric"
        [panelWidth]="searchCheckboxAutocompleteWidth"
        (fetchItemsOptions)="filterOptionsFacade[name + 'LoadAll']($event)"
      >
      </ui-chips-with-search-generic-and-checkboxes>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.RadioButtonListPopup">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <mat-chip-grid #chipList (click)="openRadioDialog()">
          <span *ngIf="filtersFormControlOrGroup.value && label === userItemEnum.Roles">
            <mat-chip-row [removable]="true" (removed)="remove()">
              {{ filtersFormControlOrGroup.value | roleGroupPipe }}
              <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
            </mat-chip-row>
          </span>
          <span *ngIf="filtersFormControlOrGroup.value && label === userItemEnum.Locations">
            <mat-chip-row [removable]="true" (removed)="remove()">
              {{ selectedLocation }}
              <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
            </mat-chip-row>
          </span>
          <input [matChipInputFor]="chipList" [readOnly]="true" class="pointer" />
        </mat-chip-grid>
      </mat-form-field>
    </ng-container>
  </div>
</ng-container>
